var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"base-mit-url-params"},_vm._l((_vm.params),function(val,name,index){return _c('v-chip',{key:index,staticClass:"mr-1",attrs:{"close":"","color":"primary","label":""},on:{"click:close":function($event){return _vm.remove(name, val)}}},[_vm._v(_vm._s(name)+"="+_vm._s(_vm.displayFormat(val)))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }